import { css } from '@emotion/react';
import { flex } from '../../styles/utils';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { colors } from '../../styles/colors';
import { zee5PlayerIcons } from '../../fonts/customFontsConfig';

export const quizWrapperStyle = css`
  ${flex('column', 'center', 'center')};
  width: 100%;
  gap: 60px;
  padding: 24px;
  ${MQ.MediaMd} {
    width: 610px;
  }
`;

export const headerTournamentLogoStyle = css`
  width: 85px;
  ${MQ.MediaMd} {
    width: 120px;
  }
`;

export const quizScreenBgStyle = (backgroundImage: string) => css`
  background-image: url(${backgroundImage});
  background-position: center center;
  background-size: cover;
  position: relative;
  background-repeat: no-repeat;
`;

export const sponserWrapper = css`
  ${flex('column', 'center', 'center')};
  width: 100%;
  gap: 24px;
`;

export const sponserWrapperStyle = css`
  display: flex;
  gap: 4px;
  margin-top: 20px;
  margin-bottom: 20px;

  & p {
    ${ZeeFontRegular(10, 22)};
  }

  & img {
    width: 91px;
  }

  ${MQ.MediaMd} {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const quizOptionsListStyle = css`
  ${flex('column', 'center', 'center')};
  gap: 16px;
  width: 100%;
`;

export const quizOptionStyle = css`
  text-align: center;
  color: #fbfbfc;
  cursor: pointer;
  ${ZeeFontMedium(14, 22)};
  font-weight: 600;
  list-style: none;
  border-radius: 4px;
  width: 100%;
  border: 1px solid var(--color-white-white-50, #ffffff80);
  padding: 24px;
  ${MQ.MediaMd} {
    width: 328px;
  }
`;

export const itemSelectedStyle = css`
  border: 1px solid #ffffffcc;
  background-color: #554a4c;
`;

export const quizTitleStyle = css`
  ${ZeeFontBold(21, 30)};
  font-weight: 900;
  text-align: center;
  font-style: italic;
  color: ${colors.PrimaryWhiteColor};
`;

export const ctaWrapperStyle = css`
  ${flex('row', 'center', 'center')};
  gap: 16px;
  width: 100%;
  padding: 24px;
  ${MQ.MediaMd} {
    width: 328px;
    padding: 24px 0;
  }
`;

export const quizCtaStyle = css`
  ${flex('row', 'center', 'center')};
  gap: 4px;
  width: 100%;
  text-align: center;
  padding: 8px 16px;
  border-style: none;
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(12, 18)};
  cursor: pointer;
  ${MQ.MediaMd} {
    padding: 12px 0;
    ${ZeeFontBold(14, 20)};
  }
`;

export const quizCloseBtnStyle = css`
  background-color: transparent;
`;

export const quizSubmitBtnStyle = css`
  border: 1px solid var(--color-border-Primary, #ffffff);
  background-color: #ffffff1f;
  border-radius: 4px;
`;

export const quizBtnDisabledStyle = css`
  border: 1px solid var(--color-disabled-Primary, #665a70);
  background-color: transparent;
  border-radius: 4px;
  color: #665a70;
`;

export const quizCtaIconStyle = css`
  width: 16px;
  height: 16px;
`;

export const playIconStyle = css`
  ${MQ.MediaLg} {
    width: 18px;
    height: 18px;
  }
`;
export const muteIconStyle = css`
  width: 20px;
  height: 20px;
  ${MQ.MediaLg} {
    width: 24px;
    height: 24px;
  }
`;
export const unmuteBtn = css`
  &::before {
    content: 'U';
    font-family: ${zee5PlayerIcons.style.fontFamily};
    color: ${colors.PrimaryWhiteColor};
    font-size: 20px;
    ${MQ.MediaLg} {
      font-size: 24px;
    }
  }
`;

export const quizContainerStyle = css`
  justify-content: flex-start;
  background-color: transparent;
  z-index: 100;
  min-height: 100vh;
`;

// Result screen styles

export const quizResultWrapper = css`
  ${flex('column', 'flex-start', 'center')};
  gap: 40px;
  ${MQ.MediaMd} {
    width: 610px;
  }
`;

export const quizResultHeaderStyle = css`
  ${flex('column', 'flex-start', 'center')};
  gap: 48px;
  padding: 0 36px;
`;

export const quizResultTitleStyle = css`
  ${ZeeFontBold(24, 40)};
  text-align: center;
  font-style: italic;
  color: ${colors.PrimaryWhiteColor};
  ${MQ.MediaMd} {
    ${ZeeFontBold(40, 55)};
  }
`;

export const quizResultDescStyle = css`
  ${ZeeFontRegular(14, 20)};
  text-align: center;
  color: ${colors.PrimaryWhiteColor};
`;

export const quizResultBtnStyle = css`
  background-color: transparent;
  border: none;
  padding: 8px;
`;
export const watchBtnStyle = css`
  background-color: #ffffff1f;
  border: 1px solid ${colors.PrimaryWhiteColor};
  border-radius: 2px;
  padding: 8px;
`;

export const resultImgStyle = css`
  width: 100%;
  padding: 16px;
  object-fit: fill;
  ${MQ.MediaMd} {
    width: 390px;
  }
`;
export const sponserVideoPlayer = css`
  width: 100%;
  object-fit: fill;
  border-radius: 4px;
  ${MQ.MediaMd} {
    width: 390px;
  }
`;
export const sponserPlayerContainer = css`
  padding: 16px;
  position: relative;
`;
export const controlsContainer = css`
  position: absolute;
  top: 32px;
  right: 32px;
`;
export const muteBtn = css`
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;

export const quizResultCtaWrapper = css`
  ${flex('row', 'center', 'center')};
  gap: 16px;
  width: 80%;
`;

export const quizStatusBarWrapper = css`
  ${flex('row', 'center', 'center')};
  gap: 12px;
  width: 100%;
`;

export const quizStatusBarIconStyle = css`
  width: 12px;
  height: 12px;
`;
